import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SocketService } from '../common/socket.service';
import { SnackbarService } from '../common/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationSyncService {
  
  // 1. Private Subjects (these CAN use .asObservable())
  private unreadCountSubject = new BehaviorSubject<number>(0);
  private newNotificationSubject = new BehaviorSubject<any>(null);

  // Create a specific stream for marking all as read
  private markAllReadSubject = new Subject<void>();
  public markAllRead$: Observable<void> = this.markAllReadSubject.asObservable();

  // 2. Public Observables (these are regular Observables, DO NOT call .asObservable() on them)
  public unreadCount$: Observable<number> = this.unreadCountSubject.asObservable();
  public newNotification$: Observable<any> = this.newNotificationSubject.asObservable();

  constructor(
    private socketServ: SocketService,
    private snackbarServ: SnackbarService
  ) {
    this.setupSocketListener();
  }

  private setupSocketListener(): void {
       this.socketServ.socketConnected$.subscribe((isConnected) => {
        if (isConnected && this.socketServ.socket) {
          this.initNotificationListener();
        }
      });
  }

  private initNotificationListener(): void {
    this.socketServ.socket.off('receiveAppNotification');

    this.socketServ.socket.on('receiveAppNotification', (response: any) => {

      if (response && response.data) {
        this.incrementUnreadCount();
        this.newNotificationSubject.next(response.data);

      }
    });
  }

  notifyAllMarkedAsRead(): void {
    this.markAllReadSubject.next();
  }
  

  // Getters and Setters
  getUnreadCount(): Observable<number> {
    return this.unreadCount$; // Return directly, no .asObservable()
  }

  setUnreadCount(count: number): void {
    this.unreadCountSubject.next(Math.max(0, count));
  }

  incrementUnreadCount(): void {
    const currentCount = this.unreadCountSubject.value;
    this.unreadCountSubject.next(currentCount + 1);
  }

  decrementUnreadCount(): void {
    const currentCount = this.unreadCountSubject.value;
    this.unreadCountSubject.next(Math.max(0, currentCount - 1));
  }

  clearUnreadCount(): void {
    this.unreadCountSubject.next(0);
  }

  getNewNotifications(): Observable<any> {
    return this.newNotification$; // Return directly, no .asObservable()
  }
}